import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { agreementFields } from '../../api/applicationData';

const Agreement = forwardRef(({ newApplicant, setNewApplicant }, ref) => {
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      const newErrors = {};
      agreementFields.forEach(({ key }) => {
        if (!newApplicant?.agreements?.[key]) {
          newErrors[key] = 'This agreement is required';
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
  }));

  const handleCheckbox = (key) => {
    setNewApplicant((prev) => ({
      ...prev,
      agreements: {
        ...prev.agreements,
        [key]: !prev?.agreements?.[key],
      },
    }));
    setErrors((prev) => ({ ...prev, [key]: '' }));
  };

  return (
    <div className="space-y-10">
      {agreementFields.map(({ key, statement }) => (
        <div key={key} className="mb-4">
          <div className="flex justify-between items-center align-middle">
            <div className="text-sm text-slate-700 mr-10">{statement}</div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox w-5 h-5"
                checked={!!newApplicant?.agreements?.[key]}
                onChange={() => handleCheckbox(key)}
              />
            </label>
          </div>
          {errors[key] && (
            <div className="text-red-500 text-xs mt-1">{errors[key]}</div>
          )}
        </div>
      ))}
    </div>
  );
});

export default Agreement;
